import React, { useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { priceDecimalFormatter } from 'formatter/preset.formatter';

const UpdatePaymentModal = ({
  totalPrice,
  preset,
  show,
  onClose,
  currentModel,
  setCurrentModel,
}) => {
  const debounceTimer = useRef(null);
  const onHandlePress = type => {
    onClose();
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      setCurrentModel(type);
    }, 1000);
  };
  return (
    <Modal show={show} onHide={onClose}>
      <button
        className="close"
        type="button"
        data-dismiss="modal"
        aria-label="Close"
        onClick={onClose}
      />
      <Modal.Header>
        <h3>Choose your payment method</h3>
      </Modal.Header>
      <Modal.Body>
        <>
          <div className="card-footer p-3">
            <button
              type="button"
              // name="paymentMethod"
              value="card"
              onClick={() => onHandlePress('card')}
              className="btn btn-block btn-primary"
            >
              Click to Update Credit Card
              {/* Pay ${priceDecimalFormatter(totalPrice)} */}
              <img
                src="/assets/img/debit-card-color.png"
                width={30}
                height={30}
                alt="card icon"
                className=" ml-2"
              />
            </button>
            <div className="position-relative my-4">
              <hr />
              <span
                className="position-absolute or-seperator p-2"
                style={{
                  top: '-18px',
                  left: '50%',
                  backgroundColor: '#f5f5f5',
                }}
              >
                OR
              </span>
            </div>
            <button
              type="button"
              // name="paymentMethod"
              value="eft"
              onClick={() => onHandlePress('eft')}
              className="btn btn-block border-primary"
            >
              <span>Click to Update EFT</span>
              {/* <span>Pay with EFT</span> */}
              <span className="d-flex align-items-center">
                <img
                  src="/assets/img/interac.png"
                  width={30}
                  height={30}
                  alt="eft icon"
                  className=" ml-2"
                />
                <small className="font-bold">Verified</small>
              </span>
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default UpdatePaymentModal;
